import { DatePicker, Select } from "antd";
import _ from "lodash";
import moment from "moment";
import QueryString from "qs";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from "react-router-dom";
import { getPtStatsByGradeByType, getPtStatsByLevelByType, getPtStatsByQuestion, getPtStatsByStudent, getPtStatsSummaryByType } from "../../../api/statistics.api";
import { getExams, getTestTypes } from "../../../api/testCenter.api";
import Button from "../../Button";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import PtStatsByGrade from "../../statistics/placement-test/PtStatsByGrade";
import PtStatsByQuestion from "../../statistics/placement-test/PtStatsByQuestion";
import PtStatsByStudent from "../../statistics/placement-test/PtStatsByStudent";
import PtStatsSummary from "../../statistics/placement-test/PtStatsSummary";
import MultiCampusModal from "../../statistics/regular-test/modals/MultiCampusModal";
import TabItem from "../../statistics/TabItem";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import config from "../../../lib/config";
import { IGetExamStatsByQuestion, IGetPtStatsByGrade, IGetPtStatsByLevel, IGetPtStatsByStudent, IGetPtStatsSummary } from "../../../models/statistics.model";
import { IGetExams, IGetTestTypes, ITestType } from "../../../models/testCenter.model";
import { RootState } from "../../../store/rootReducer";
import { IGetCurrentSemester, IGetSemesters } from "../../../models/semesters.model";
import { getCurrentSemester, getSemesters } from "../../../api/semesters.api";
import EduStepSelect from "../../../components/common/EduStepSelect";
import SelectCampus from "../../SelectCampus";
import PtStatsByLevel from "./PtStatsByLevel";
import TableEmpty from "../../common/TableEmpty";
import SelectCampusMultiChoice from "../../SelectCampusMultiChoice";

enum Contents {
  Summary,
  Grade,
  Level,
  Student,
  Question
}

const PtStatsByExam = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const { auth } = useSelector((state: RootState) => state.auth);
  const { infoNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetTestTypes>();
  const { data: res2, isLoading: isLoading2, error:error2, execute: execute2 } = useAxios<IGetSemesters>();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios<IGetPtStatsSummary|IGetPtStatsByGrade|IGetPtStatsByStudent|IGetPtStatsByLevel>();
  const { data: res4, isLoading: isLoading4, error: error4, execute: execute4 } = useAxios<IGetExamStatsByQuestion>();
  const { data: res6, isLoading: isLoading6, execute: execute6 } = useAxios<IGetCurrentSemester>();

  const [content, setContent] = useState<Contents>(Contents.Summary);
  const [isFirstRun, setIsFirstRun] = useState(true);
  const [isInitDataChk, setIsInitDataChk] = useState(true);
  const [questionData, setQuestionData] = useState<IGetExamStatsByQuestion>();
  const [params, setParams] = useState();
  const [eduStepCode, setEduStepCode] = useState<string>();
  const [examTypeCode, setExamTypeCode] = useState<number>();
  const [examCode, setExamCode] = useState<number>();
  const [types, setTypes] = useState<ITestType[]>([]);
  const [semesterCode, setSemesterCode] = useState<number>();

  const [srtDate, setSrtDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [campusCodes, setCampusCodes] = useState<string[]>([]);
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const [multiCampusVisible, setMultiCampusVisible] = useState(false);
  // 탭 컨텐츠 내 페이지
  const [pageNo, setPageNo] = useState(1);
  const [examSubjectCode, setExamSubjectCode] = useState<number>();
  // 엑셀다운로드 Title
  const [excelCampusCodes, setExcelCmpusCodes] = useState<string[]>([]);
  const [excelPeriod, setExcelPeriod] = useState<string>('');
  const { campusData } = useSelector((state: RootState) => state.campusData);

  useEffect(() => {
    execute(getTestTypes());
    execute2(getSemesters());
    execute6(getCurrentSemester());
    setEduStepCode(undefined);

    defSelectBoxSetting();
  }, []);

  const defSelectBoxSetting = () => {
    //검색 필드 Default값 셋팅
    const defSelValue:any = "";    
    setExamTypeCode(defSelValue);
  }

  useEffect(() => {
    if (res && !isLoading) {
      const _types = _.clone(res?.data)?.filter((item) => item.examDiv === 'PT');
      setTypes(_types);
    }
  }, [res, isLoading]);

  useEffect(() => {
    const _params: any = {};
    if (isFirstRun) {
      setIsInitDataChk(false);  //첫 컴포넌트 로드 시에는 초기 Data 조회 false ex) 상위 탭 누르는 경우
    } else {
      setIsInitDataChk(true); //하위 탭 변경 시에는 Data 조회 처리 위해 true 변경
    }

    if (query.idx) {
      _params.idx = Number(query.idx);
      setContent(_params.idx);
    }

    setParams(_params);
  }, [location]);
  
  useEffect(() => {
    if (isFirstRun) {
      setIsFirstRun(false);
      return;
    }

    //첫 컴포넌트 로드 시에는 초기 Data 조회 처리 되지 않도록 추가 ex) 상위 탭 누르는 경우
    if(!isInitDataChk) {
      setIsInitDataChk(true);
      return;
    }
    
    if(content !== Contents.Question || examSubjectCode) {
      getPtStats();
    } else {
      //탭이 변경되거나 과목코드 조건이 바뀌는 경우 문항 테이블 초기화 처리
      setQuestionData(undefined);
    }

    //문항 탭 + 시험유형이 '전체'인 경우 유형 필드 초기화(문항탭에서는 유형 '전체' 제거)
    if(content === Contents.Question && !examTypeCode) {
      setExamTypeCode(undefined);
    }
  }, [content, pageNo, examSubjectCode]);

  useEffect(() => {
    //현재 학기/일자 로 셋팅
    if (res6 && !isLoading6) {
      if (res6?.data?.semesterCode) {
        setSemesterCode(res6.data.semesterCode);
        setSrtDate(res6.data.semesterSrtDate);
        setEndDate(res6.data.semesterEndDate);
      } else {
        setSemesterCode(undefined);
      }
    }
  }, [res6, isLoading6]);

  useEffect(() => {
    if (res4 && !isLoading4) {
      setQuestionData(res4);
    }
  }, [res4, isLoading4]);

  const getTypes = () => {
    if (eduStepCode) {
      return types.filter(type => type.eduStepCode === eduStepCode);
    }
    return types;
  };

  const getPtStats = (_pageNo?: number) => {
    if (!srtDate) {
      return infoNotification(t('statistics.placementTest.message2'));
    }
    if (!endDate) {
      return infoNotification(t('statistics.placementTest.message3'));
    }
    //최대 검색 기간 조건 추가
    const momentSrtDate = moment(srtDate);
    const momentEndDate = moment(endDate);
    const diffDay = moment.duration(momentEndDate.diff(momentSrtDate)).asDays();
    if(diffDay > 365) {
      return infoNotification(t('statistics.placementTest.message5'));
    }

    if (!eduStepCode) {
      return infoNotification(t('program.course.1'));
    }
    if (_pageNo) {
      setPageNo(_pageNo);
    }

    const req = {
      srtDate,
      endDate,
      campusCode: auth.hqYn === 'Y'
        ? campusCodes
        : (campusCodes.length ? campusCodes : auth.campus),
      campusCodeOne: currentCampus,
      eduStepCode,
      examTypeCode,
    }

    setExcelPeriod(srtDate + " ~ " + endDate);
    if(campusData.length === campusCodes.length) {
      setExcelCmpusCodes([]);
    } else {
      setExcelCmpusCodes(campusCodes);
    }

    switch (content) {
      case Contents.Summary:
        execute3(getPtStatsSummaryByType(req));
        break;
      case Contents.Grade:
        execute3(getPtStatsByGradeByType(req));
        break;
      case Contents.Level:
        execute3(getPtStatsByLevelByType(req));
        break;
      /*  
      case Contents.Student:
        
        execute3(getPtStatsByStudent(examCode, {
          ...req,
          pageNo: _pageNo || pageNo,
          perPage: config.pageSize,
        }));
        
        break;
      */
      case Contents.Question:
        if (examSubjectCode) {
          if (!examCode) {
            return infoNotification(t('statistics.placementTest.message1'));
          }
          execute4(getPtStatsByQuestion(examCode, {
            ...req,
            examSubjectCode
          }));   
        } else {
          if(!examTypeCode) {
            return infoNotification(t('cbt.test.message2'));
          } else {
            return infoNotification(t('cbt.type.message3'));
          }
          
        }
        
        break;
    }
  };

  const renderContent = () => {
    switch (content) {
      case Contents.Summary:
        return (
          <PtStatsSummary
            // @ts-ignore 
            rawData={res3?.data}
            excelCampusCodes={excelCampusCodes}
            excelPeriod={excelPeriod}
          />
        );
      case Contents.Grade:
        return (
          <PtStatsByGrade
            // @ts-ignore 
            rawData={res3?.data}
            excelCampusCodes={excelCampusCodes}
            excelPeriod={excelPeriod}
          />
        );
      case Contents.Level:
        return (
          <PtStatsByLevel
            // @ts-ignore 
            rawData={res3?.data}
            eduStepCode={eduStepCode}
            excelCampusCode={currentCampus}
            excelPeriod={excelPeriod}
          />
        );
      /*   
      case Contents.Student:
        return (
          <PtStatsByStudent
            // @ts-ignore
            rawData={res3?.data}
            // @ts-ignore
            total={res3?.total}
            pageNo={pageNo}
            setPageNo={setPageNo}
            examCode={examCode}
            srtDate={srtDate}
            endDate={endDate}
            campusCodes={campusCodes}
          />
        );
      */
      case Contents.Question:
        return (
          <PtStatsByQuestion
            // @ts-ignore 
            //data={res4?.data}
            data={questionData?.data}
            examCode={examCode}
            examTypeCode={examTypeCode}
            examSubjectCode={examSubjectCode}
            eduStepCode={eduStepCode}
            setExamSubjectCode={setExamSubjectCode}
            setExamCode={setExamCode}
          />
        );
    }
  };

  const onSetContent = (_content: Contents) => {
    let _params: any = {};
    if (params) {
      // @ts-ignore
      _params = { ...params, idx: _content };
    }
    history.push(`/statistics/placement-test?${QueryString.stringify(_params)}`);
  };
  
  return (
    <>
      <div className="common-search">
        <div className="search-area">
          <ul className="search-bx">
            <li>
              <label>{t('common.menu.campus')}</label> {/* 캠퍼스 */}
              {
                content !== Contents.Level
                ? (
                  <>
                    <SelectCampusMultiChoice
                      placeholder={t('statistics.eLearning.title2')}
                      onChange={setCampusCodes}
                      value={campusCodes}
                    />
                    <label>
                      ({campusCodes.length ? `${campusCodes.length}${t('statistics.attendance.text1')}` : t('common.text.all')})
                    </label>
                  </>
                  )
                : <SelectCampus />
              }
            </li>
            <li>
              <label>{t('common.column.semester')}</label> {/* 학기 */}
              <Select
                placeholder={t('statistics.regularTest.placeholder2')}
                value={semesterCode}
                onChange={value => {
                  setSemesterCode(value);
                  res2?.data?.map(item => {
                    if(item.semesterCode === value) {
                      setSrtDate(item.semesterSrtDate);
                      setEndDate(item.semesterEndDate);
                    }
                  });
                }}
              >
                {res2?.data?.filter(item => item.semesterType === 'RG').map(item => (  
                  <Select.Option
                    key={item.semesterCode}
                    value={item.semesterCode}
                  >
                    {item.semesterName}
                  </Select.Option>
                ))}
              </Select>
            </li>
            <li>
              <label>{t('sms.list.column1')}</label> {/* 기간 */}
              <div className="date-picker__area">
                <DatePicker
                  value={srtDate ? moment(srtDate) : undefined}
                  onChange={e => {
                    if (e === null) setSrtDate('');
                    else setSrtDate(moment(e).format('YYYYMMDD'))
                    
                    setSemesterCode(undefined);
                  }}
                  format={['YYYY-MM-DD', 'YYYYMMDD']}
                />
              </div>
              ~
              <div className="date-picker__area">
                <DatePicker
                  value={endDate ? moment(endDate) : undefined}
                  onChange={e => {
                    if (e === null) setEndDate('');
                    else setEndDate(moment(e).format('YYYYMMDD'))
                    
                    setSemesterCode(undefined);
                  }}
                  format={['YYYY-MM-DD', 'YYYYMMDD']}
                />
              </div>
            </li>
            <li>
              <label>{t('common.placeholder.1')}</label> {/* 교육단계 */}
                <EduStepSelect
                  eduStepCode={eduStepCode}
                  setEduStepCode={value => {
                    setEduStepCode(value);
                    const defSelValue:any = "";
                    setExamTypeCode(defSelValue);
                    setExamSubjectCode(undefined);
                  }}
                  placeholder={t('statistics.regularTest.placeholder2')}
                />
            </li>
            <li>
              <label>{t('statistics.placementTest.placeholder1')}</label> {/* 유형 */}
              <Select
                placeholder={t('statistics.placementTest.placeholder1')}
                value={examTypeCode}
                onChange={value => {
                  setExamTypeCode(value);
                  setExamSubjectCode(undefined);
                }}
              >
                {
                  content !== Contents.Question ? (
                    <Select.Option value="">{t('common.text.all')}</Select.Option>
                  ) : null
                }
                {getTypes().map(item => (
                  <Select.Option
                    key={item.examTypeCode}
                    value={item.examTypeCode}
                  >
                    {item.examTypeName}
                  </Select.Option>
                ))}
              </Select>
              <div className="comm-btn__area">
                <Button
                  className="btn-basic small black"
                  onClick={() => getPtStats(1)}
                  text={t('common.button.search')}
                />
              </div>
            </li>
          </ul>
        </div>
        <div className="comm-bx__between">
          🏷️ {t('statistics.placementTest.message4')}
        </div>
      </div>	

      {(isLoading || isLoading3 || isLoading4) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={error4} />

      
      {
        res3?.data || content === Contents.Question
          ? (
            <div>
              <div className="comm-tab__line">
                <ul>
                  <TabItem
                    currentContent={content}
                    onSetContent={onSetContent}
                    tabContent={Contents.Summary}
                    tabLabel={t('statistics.attendance.Tab1')}
                  />
                  <TabItem
                    currentContent={content}
                    onSetContent={onSetContent}
                    tabContent={Contents.Grade}
                    tabLabel={t('student.student.column3')}
                  />
                  <TabItem
                    currentContent={content}
                    onSetContent={onSetContent}
                    tabContent={Contents.Level}
                    tabLabel={t('statistics.dttt.column1')}
                  />
                  {/*<TabItem
                    currentContent={content}
                    onSetContent={onSetContent}
                    tabContent={Contents.Student}
                    tabLabel={t('common.menu.student')}
                    />*/}
                  <TabItem
                    currentContent={content}
                    onSetContent={onSetContent}
                    tabContent={Contents.Question}
                    tabLabel={t('statistics.placementTest.tab1')}
                  />
                </ul>
              </div>
              <div className="custom-tabs-tabContent">
                {renderContent()}
              </div>
            </div>
            )
          : isLoading || isLoading3
            ? null
            : (
              <TableEmpty text={t('statistics.appday.text1')} />
              )
        } 

      {multiCampusVisible &&
        <MultiCampusModal
          visible={multiCampusVisible}
          setVisible={setMultiCampusVisible}
          campusCodes={campusCodes}
          setCampusCodes={setCampusCodes}
        />
      }
    </>
  );
}

export default PtStatsByExam;
